import "./App.scss";
import "react-toastify/dist/ReactToastify.css";
import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "./common/Button";
import {useDispatch, useSelector} from "react-redux";
import {rxToggleExpiredModal} from "./slices/appSlice";
import {useTranslation} from "react-i18next";
import useProject from "./util/useProject";
import useFormat from "./util/useFormat";
import {Link} from "react-router";

export const ExpiredModal = () => {
  const dispatch = useDispatch();

  const {expirationDate} = useProject();
  const {formatDate} = useFormat();

  const {t} = useTranslation("app")

  const expiredModal = useSelector(state => state.app.expiredModal);

  const hideModal = () => dispatch(rxToggleExpiredModal());

  return <Modal show={expiredModal}>
    <Modal.Header>
      <Modal.Title>{t("expired_modal_title")}</Modal.Title>
    </Modal.Header>
    <Modal.Body>
      <p>{t("expired_modal_project_expired", {date: formatDate(expirationDate)})}</p>
      <p>{t("expired_modal_go_to_settings")}</p>
      <p><Link to="/settings/subscription" onClick={hideModal}>{t("expired_modal_settings_link")}</Link></p>
    </Modal.Body>
    <Modal.Footer>
      <Button variant="primary" onClick={hideModal}>{t("expired_modal_btn_close")}</Button>
    </Modal.Footer>
  </Modal>;
};
